// =================================================================================================
// © 2021 Shrewd Apps
// ALL RIGHTS RESERVED.

import React, { useState } from "react";
import { Toast, ToastContainer } from "react-bootstrap";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";

import { getLocalStorage, setLocalStorage } from "global/utilities/browserStorage";

// -------------------------------------------------------------------------------------------------
export default function AcceptCookiesPrompt() {
	const [isToastOpen, setIsToastOpen] = useState(haveAcceptedCookies());
	const acceptCookies = () => {
		setAcceptedCookies();
		setIsToastOpen(false);
	};

	return (
		<div aria-live="polite" aria-atomic="true" >
			<ToastContainer position="top-middle" containerPosition="fixed" className="text-center start-50 top-0 translate-middle-x" style={{ zIndex: 1 }}>
				<Toast bg="light" className="m-3 p-3" show={isToastOpen}>
					<Toast.Body>
						<p>MTG Top Decks uses cookies for functional and analytical purposes. Please read our <Link to="/cookies">Cookie Policy</Link> for more information.</p>
						<hr />
						<Button color="primary" style={{ cursor: "pointer" }} onClick={() => acceptCookies()}>I agree</Button>
					</Toast.Body>
				</Toast>
			</ToastContainer>
		</div>
	);
}

// -------------------------------------------------------------------------------------------------
function haveAcceptedCookies() {
	return !getLocalStorage("acceptedCookies");
}

// -------------------------------------------------------------------------------------------------
function setAcceptedCookies() {
	setLocalStorage("acceptedCookies", true);
}